import axios from 'axios';
import router from '../router';
import {message} from './message'
import CryptoJS from 'crypto-js';
import { Base64 } from 'js-base64';

axios.defaults.timeout = 300000;

//http request 拦截器
axios.interceptors.request.use(
	config => {
		config.data = JSON.stringify(config.data);
		config.headers = {
			'X-Requested-With': 'XMLHttpRequest',
			'Content-Type': 'application/json; charset=UTF-8',
			token : JSON.parse(localStorage.getItem('token'))
		}
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
	if( response.data.code === 1000) {
		message({
			message: '登录超时,请重新登录!',
			type: 'error'
		});
		setTimeout(() => {
			localStorage.clear();
			sessionStorage.clear();
			location.href = '/Login';
			// router.push({
			// 	path: '/Login',
			// })
			webrtcSDK.destory();
		}, 1000);
	}
	response => {
		if (response.status === 200) {
			return Promise.resolve(response);
		} else {
			return Promise.reject(response);
		}
	}
	return response
}, err => {
	if (err && err.response) {
	  switch (err.response.status) {
		case 400:
			message({
				message: '错误请求!',
				type: 'error'
			});
			break;
		case 401:
			message({
				message: '未授权，请重新登录!',
				type: 'error'
			});
			break;
		case 403:
			message({
				message: '拒绝访问!',
				type: 'error'
			});
			break;
		case 404:
			message({
				message: '请求错误,未找到该资源!',
				type: 'error'
			});
			break;
		case 405:
			message({
				message: '请求方法未允许!',
				type: 'error'
			});
			break;
		case 408:
			message({
				message: '请求超时!',
				type: 'error'
			});
			break;
		case 500:
			message({
				message: '服务器端出错!',
				type: 'error'
			});
			break;
		case 501:
			message({
				message: '网络未实现!',
				type: 'error'
			});
			break;
		case 502:
			message({
				message: '网络错误!',
				type: 'error'
			});
			break;
		case 503:
			message({
				message: '服务不可用!',
				type: 'error'
			});
			break;
		case 504:
			message({
				message: '网络超时!',
				type: 'error'
			});
			break;
		case 505:
			message({
				message: 'http版本不支持该请求!',
				type: 'error'
			});
			break;
		default:
			console.log(`连接错误${err.response.status}`)
	  }
	} else {
		message({
			message: '连接服务器失败,检测到您本地网络存在问题,请检查网络设置或者本地防火墙设置！',
			type: 'error'
		});
	}
	return Promise.reject(err.response)
})


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url,params={}){
	return new Promise((resolve,reject) => {
		axios.get(url,{
			params: params
		})
		.then(response => {
			if(response.data == ''){
				location.href = '/Login';
				// router.push({
				// 	path: '/Login',
				// })
				webrtcSDK.destory();
			}else{
				var user = JSON.parse(localStorage.getItem('user'));
				var memberInfo = '';

				if(user){
					memberInfo = user.memberInfo;
				}
				if(memberInfo.crypt_right == 1 && (response.data.code == 1) && response.data.data){
					const crypt_key = 'MC.1888@#!1' + memberInfo.crypt_key;
					try {
						// 将密钥转换为WordArray
						const keyHash = CryptoJS.SHA256(crypt_key);
						const parsedKey = CryptoJS.lib.WordArray.create(keyHash.words);
						
						// 解析IV和加密数据
						const parsedIv = CryptoJS.enc.Base64.parse(memberInfo.crypt_iv);
						const parsedEncryptedData = CryptoJS.enc.Base64.parse(response.data.data);
						
						// 解密
						const decrypted = CryptoJS.AES.decrypt(
							{ ciphertext: parsedEncryptedData },
							parsedKey,
							{ 
								iv: parsedIv,
								mode: CryptoJS.mode.CBC,
								padding: CryptoJS.pad.Pkcs7
							}
						);
						const decodeBuffer = Base64.decode(decrypted.toString(CryptoJS.enc.Utf8));
                        response.data.data = decodeBuffer;
                        if (typeof decodeBuffer === 'string') {
                            try {
                                var strJson = JSON.parse(decodeBuffer);
                                if (typeof strJson === 'object' && strJson !== null){
                                    response.data.data = strJson;
                                }
                            } catch (e) {

                            }
                        }
						resolve(response);
					} catch (error) {
						return '解密失败: ' + error.message;
					}
				}else{
					resolve(response);
				}
			}
		})
		.catch(function(reason) {
			reject(reason)
		})
	})
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url,data,config){
	return new Promise((resolve,reject) => {    
		axios.post(url,data,config)
		.then(response => {
			var user = JSON.parse(localStorage.getItem('user'));
			var memberInfo = '';
			if(user){
				memberInfo = user.memberInfo;
			}
			if(memberInfo.crypt_right == 1 && (response.data.code == 1) && response.data.data){
				// 解密
				const crypt_key = 'MC.1888@#!1' + memberInfo.crypt_key;
				try {
					// 将密钥转换为WordArray
					const keyHash = CryptoJS.SHA256(crypt_key);
					const parsedKey = CryptoJS.lib.WordArray.create(keyHash.words);
					
					// 解析IV和加密数据
					const parsedIv = CryptoJS.enc.Base64.parse(memberInfo.crypt_iv);
					const parsedEncryptedData = CryptoJS.enc.Base64.parse(response.data.data);
					
					// 解密
					const decrypted = CryptoJS.AES.decrypt(
						{ ciphertext: parsedEncryptedData },
						parsedKey,
						{ 
							iv: parsedIv,
							mode: CryptoJS.mode.CBC,
							padding: CryptoJS.pad.Pkcs7
						}
					);
					const decodeBuffer = Base64.decode(decrypted.toString(CryptoJS.enc.Utf8));
					response.data.data = decodeBuffer;
					if (typeof decodeBuffer === 'string') {
						try {
							var strJson = JSON.parse(decodeBuffer);
							if (typeof strJson === 'object' && strJson !== null){
								response.data.data = strJson;
							}
						} catch (e) {

						}
					}
					resolve(response);
				} catch (error) {
					return '解密失败: ' + error.message;
				}
			}else{
				// 不解密
				resolve(response);
			}
			
		},err => {
			reject(err)
		}).catch(err => {
			reject(err.data)
		})
	})
}

 /**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url,data = {}){
	return new Promise((resolve,reject) => {
		axios.patch(url,data)
		.then(response => {
			resolve(response.data);
		},err => {
			reject(err)
		})
	})
}

 /**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url,data = {}){
	return new Promise((resolve,reject) => {
		axios.put(url,data)
			.then(response => {
			resolve(response.data);
		},err => {
			reject(err)
		})
	})
}




// WEBPACK FOOTER //
// ./src/api/axios.js